import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useRoutesStore } from 'store';

import { SOFTWARE_MANAGEMENT_ROUTES } from '../../index';

interface IDeploymentPageNavigation {
    navigateToDeploymentCreate: () => void;
    navigateToDeploymentList: () => void;
}

export const useDeploymentPageNavigation = (): IDeploymentPageNavigation => {
    const navigate = useNavigate();
    const routeStore = useRoutesStore();
    const deploymentCreateRoute = routeStore.getRoute(SOFTWARE_MANAGEMENT_ROUTES.DEPLOYMENTS_MODIFY);
    const deploymentListRoute = routeStore.getRoute(SOFTWARE_MANAGEMENT_ROUTES.DEPLOYMENTS_VIEW);

    return {
        navigateToDeploymentCreate: React.useCallback(
            (): void => navigate(deploymentCreateRoute.path),
            [deploymentCreateRoute.path, navigate],
        ),
        navigateToDeploymentList: React.useCallback(
            (): void => navigate(deploymentListRoute.path),
            [deploymentListRoute.path, navigate],
        ),
    };
};
